import { render, staticRenderFns } from "./CreationOptions.vue?vue&type=template&id=5a6f47c7&scoped=true&"
import script from "./CreationOptions.vue?vue&type=script&lang=js&"
export * from "./CreationOptions.vue?vue&type=script&lang=js&"
import style0 from "./CreationOptions.vue?vue&type=style&index=0&id=5a6f47c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6f47c7",
  null
  
)

export default component.exports